module.exports = __webpack_public_path__ + "img/fjds-wechat.3b9249ee.jpeg";